export default {
  install(Vue, options) {
    // 4. add an instance method
    Vue.prototype.$ntSetError = function (title,msg) {
      this.$vs.notify({
        title: title || 'warning',
        text: msg || 'Error receiving information',
        color: 'danger',
        position:'bottom-left'
      })
    }

    Vue.prototype.$ntSet = function (msg) {
      this.$vs.notify({
        title: 'Successful',
        text: msg || 'save information',
        color: 'primary',
        position:'bottom-right'
      })
    }

    Vue.prototype.$ntRemove = function (msg) {
      this.$vs.notify({
        title: 'warning',
        text: msg || '',
        color: 'warning',
      })
    }

    Vue.prototype.$ntSuccess = function (msg) {
      this.$vs.notify({
        title: 'Successful',
        text: msg || '',
        color: 'success',
        position:'bottom-right'
      })
    }

    Vue.prototype.$ntGetError = function (msg) {
      this.$vs.notify({
        title: 'خطا در ثبت اطلاعات',
        text: msg || 'در اطلاعات دریافت شده خطایی رخ داده ',
        color: 'danger',
      })
    }
  }
};
